import React from "react";
import DrumCountStep from "./steps/DrumCountStep";
import ReadBarcodeStep from "./steps/ReadBarcodeStep";
import DetectObjectStep from "./steps/DetectObjectStep";
import QuestionStep from "./steps/QuestionStep";
import IterateStep from "./steps/IterateStep";

interface StepRendererProps {
  step: any;
  drumCount: number | null;
  onStepComplete: (data?: any) => void;
}

const StepRenderer: React.FC<StepRendererProps> = ({
  step,
  drumCount,
  onStepComplete,
}) => {
  // Check if this is an iterate step
  if (step.iterate) {
    return (
      <IterateStep
        iterateSteps={step.iterate}
        drumCount={drumCount}
        onIterateComplete={onStepComplete}
      />
    );
  }

  // Handle regular steps based on type
  if (step.type === "get_drum_count") {
    return (
      <DrumCountStep
        humanText={step.human_text}
        onComplete={onStepComplete}
      />
    );
  }

  if (step.type === "read_barcode") {
    return (
      <ReadBarcodeStep
        humanText={step.human_text}
        onComplete={onStepComplete}
      />
    );
  }

  if (step.type === "detect_object") {
    return (
      <DetectObjectStep
        humanText={step.human_text}
        key={step.human_text}
        target={step.target}
        backend={step.backend}
        onComplete={onStepComplete}
      />
    );
  }

  if (step.question_id) {
    return (
      <QuestionStep
        questionId={step.question_id}
        onComplete={onStepComplete}
      />
    );
  }

  // Fallback for unknown step types
  return (
    <div>
      <p>Unknown step type</p>
      <pre>{JSON.stringify(step, null, 2)}</pre>
    </div>
  );
};

export default StepRenderer;
